import keys from '@debbie/common/dist/cache/keys';
import * as api from '../api/case-vouchers';
import q from '../query';
export const caseVouchersEntity = 'case-vouchers';
export const caseVouchersKey = (query, page, pageSize) => `case-vouchers-${page}-${pageSize}-${JSON.stringify(query)}`;
export const useCaseVouchers = (query, page, pageSize) => q.query(caseVouchersKey(query, page, pageSize), () => {
    return api.getMultiple(query, {
        offset: page,
        limit: pageSize,
    });
}, keys.read.collection(caseVouchersEntity));
export const caseVouchersKeyByCase = (caseId, options) => `case-vouchers-${caseId}-deleted:${options.getDeleted ? true : false}`;
export const useCaseVouchersByCase = (caseId, options = {}) => q.query(caseVouchersKeyByCase(caseId, options), () => api.getByCaseId(caseId, options), keys.read.collection(caseVouchersEntity), {
    enabled: caseId != null,
});
export const depositInsightsKey = `deposit-insights`;
export const useDepositInsights = () => q.query(depositInsightsKey, api.getDepositInsights, []);
//# sourceMappingURL=index.js.map